/** Distance threshold (km) for visit warnings (往療料 16km rule). */
export const VISIT_DISTANCE_THRESHOLD_KM = 16;

/** Kana initial groups (50音 ア行～ワ行) for patient name search. Values match backend ClinicConstants::KANA_INITIAL_GROUPS keys. */
export const KANA_INITIAL_OPTIONS = [
  { value: '', label: 'すべて' },
  { value: 1, label: 'ア行' },
  { value: 2, label: 'カ行' },
  { value: 3, label: 'サ行' },
  { value: 4, label: 'タ行' },
  { value: 5, label: 'ナ行' },
  { value: 6, label: 'ハ行' },
  { value: 7, label: 'マ行' },
  { value: 8, label: 'ヤ行' },
  { value: 9, label: 'ラ行' },
  { value: 10, label: 'ワ行' },
];

/** Sort radio value → API sort_by param mapping for home visit patient search. */
export const HOME_VISIT_PATIENT_SORT_MAP: Record<string, 'serial_number' | 'name_kana' | 'massager'> = {
  '1': 'serial_number',
  '2': 'name_kana',
  '3': 'massager',
};
